import { useMemo } from 'react';

import { PreviewJson } from 'components/code';

import { Typography, tokens } from '@cast/design-system';

import { rewriteLegacyConsoleUrlsInDetails } from '../_utils/rewriteLegacyConsoleUrl';

type Props = { details?: string };

export const NotificationDetails = ({ details }: Props) => {
  const preparedMessage = useMemo(() => {
    try {
      const parsed = JSON.parse(details || '');
      // hide slack message from notification details
      delete parsed.slackMessage;
      const rewritten = rewriteLegacyConsoleUrlsInDetails(parsed);
      return JSON.stringify(rewritten);
    } catch {
      return details;
    }
  }, [details]);

  if (!preparedMessage?.length) {
    return null;
  }

  return (
    <PreviewJson
      rootSx={{ mt: 24 }}
      data={preparedMessage}
      renderFallback={(data) => (
        <Typography
          px="35px"
          variant="P14R"
          color={tokens.theme.fg.structural.primaryOnInverse}
          py="16px"
          component="p"
        >
          {data}
        </Typography>
      )}
    />
  );
};
